import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SimpleTravelService } from '../product/simple-travel.service';
import { ReplaySubject } from 'rxjs/ReplaySubject';

@Component({
  selector: 'b4a-basic',
  template: ` `
})
export class BasicFunctionsComponent {

 $roomResponse = new ReplaySubject(1);

  constructor(public toastr: ToastrService,
              public simpleTravelService: SimpleTravelService
  ) {}

  deleteRoomTypes(dataToBeDeleted, tempRoomsArray, errorOnDeleteLastEntry, travel, success) {
    if (tempRoomsArray.length <= 1) {
      this.toastr.error(errorOnDeleteLastEntry)
    } else if (dataToBeDeleted.id === null) {
      tempRoomsArray.splice(dataToBeDeleted.index, 1)
      this.toastr.success(success)
    }else {
      for (let i = 0; i < travel.accommodation.roomTypes.length; i++) {
        for (let y = 0; y < travel.accommodation.roomTypes[i].prices.length; y++ ) {
          if (travel.accommodation.roomTypes[i].prices[y].id === dataToBeDeleted.roomType.id) {
            travel.accommodation.roomTypes[i].prices[y].deleteEntry = true;
          }
          if (travel.accommodation.roomTypes[i].prices[y].id === dataToBeDeleted.roomType.id1) {
            travel.accommodation.roomTypes[i].prices[y].deleteEntry = true;
          }
        }
      }

      this.simpleTravelService.saveSimpleTravel(travel).subscribe(
        done => {
          travel = done;
          tempRoomsArray.splice(dataToBeDeleted.index, 1)
          this.toastr.success(success)
          this.$roomResponse.next({travel, tempRoomsArray})
        })
      }
  }

  getRoomResponse() {
    return this.$roomResponse
  }


  // tslint:disable-next-line:max-line-length
  deleteAssignmentFromProduct(data, tempArrayOfAssignment, travel, lengthOfAssignment, typeOfAssignment, success, error, errorOnDeleteLastEntry?) {
    let travelResponse = {};
    let  tempArrayOfAssignmentResponse = [];
    let lengthOfAssignmentResponse = 0;
    let propertyInTravel;

    if (typeOfAssignment === 'boards') {
      propertyInTravel = 'boardUpgrades'
    }else if (typeOfAssignment === 'roomType') {
      propertyInTravel = 'roomTypes'
    }else {
      propertyInTravel = 'fromAirports'
    }
    // tslint:disable-next-line:max-line-length
    if (lengthOfAssignment > 1 && typeOfAssignment === 'airports' || lengthOfAssignment > 1 && typeOfAssignment === 'roomType' || typeOfAssignment === 'boards') {
    if (data[typeOfAssignment].id === null) {// here will go new entries which are not saved but user wants to delete it
      tempArrayOfAssignment.splice(data.index, 1)
      lengthOfAssignment--
      this.toastr.success(success)
    }else {
      if (typeOfAssignment === 'boards' || typeOfAssignment ===  'roomType') { // here will go entries from board upgrades and room types
        for (let i = 0; i < travel.accommodation[propertyInTravel].length; i++) {
          if (typeOfAssignment === 'boards') {
            if (travel.accommodation[propertyInTravel][i].id === data[typeOfAssignment].id) {
              travel.accommodation[propertyInTravel][i].deleteEntry = true;
            }
          }else {
            for (let y = 0; y < travel.accommodation[propertyInTravel][i].prices.length; y++ ) {
              if (travel.accommodation[propertyInTravel][i].prices[y].id === data.roomType.id) {
                travel.accommodation[propertyInTravel][i].prices[y].deleteEntry = true;
              }
              if (travel.accommodation[propertyInTravel][i].prices[y].id === data.roomType.id1) {
                travel.accommodation[propertyInTravel][i].prices[y].deleteEntry = true;
              }
            }
          }
        }
        lengthOfAssignment--
      }else { // here will go airport entries
console.log('uslo je u else')
      for (let i = 0; i < travel.flight.fromAirports.length; i++) {
        if (travel.flight.fromAirports[i].id === data.airports.id) {
          travel.flight.fromAirports[i].deleteEntry = true;
        }
      }
      lengthOfAssignment--
      }

      this.simpleTravelService.saveSimpleTravel(travel).subscribe(
        data => {console.log(data), this.toastr.success(success)},
        err => this.toastr.error(error),
        () => {
          if (typeOfAssignment === 'boards') {
            for (let i = 0; i < travel.accommodation.boardUpgrades.length; i++) {
              if (travel.accommodation.boardUpgrades[i].id === data.boards.id) {
                travel.accommodation.boardUpgrades.splice(i, 1)
              }
            }
          }else if (typeOfAssignment === 'roomType') {
            for (let y = 0; y < travel.accommodation.roomTypes.length; y++) {
                      for (let i = 0; i < travel.accommodation.roomTypes[y].prices.length; i++ ) {
                        if (travel.accommodation.roomTypes[y].prices[i].id === data.roomType.id) {
                          travel.accommodation.roomTypes[y].prices.splice(i, 1)
                        }else if (travel.accommodation.roomTypes[y].prices[i].id === data.roomType.id1) {
                          travel.accommodation.roomTypes[y].prices.splice(i, 1)
                        }
                      }
                    }
          }else {
            for (let i = 0; i < travel.flight.fromAirports.length; i++) {
              if (travel.flight.fromAirports[i].id === data.airports.id) {
                travel.flight.fromAirports.splice(i, 1)
              }
            }
          }
          tempArrayOfAssignment.splice(data.index, 1)
          travelResponse = travel;
          tempArrayOfAssignmentResponse = tempArrayOfAssignment;
        })
    }
  }else {
      this.toastr.error(errorOnDeleteLastEntry)
  }
    lengthOfAssignmentResponse = tempArrayOfAssignment.length;

    return {travel, tempArrayOfAssignment, lengthOfAssignmentResponse}
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/basic.functions.ts